import { ValidationError } from './ValidationError';
export function validateIsDefined(varName, varValue) {
    if (varValue === undefined) {
        throw new ValidationError(`Expected ${varName} to not be undefined.`);
    }
}
export function validateIsNotNegativeInteger(varName, varValue, allowUndefined = false) {
    if (allowUndefined && varValue === undefined) {
        return;
    }
    validateIsDefined(varName, varValue);
    if (!Number.isInteger(varValue)) {
        throw new ValidationError(`Expected ${varName} to be an integer but was a ${typeof varValue} (${varValue}).`);
    }
    if (varValue < 0) {
        throw new ValidationError(`Expected ${varName} to not be negative (${varValue}).`);
    }
}
